


































import {Vue, Component, Watch, Prop, Emit} from 'vue-property-decorator';
//<i class="fas fa-font"></i>

export interface TagSearchAppendItem {
  name: string;
  icon: string;
  showCondition: boolean
}

@Component
export default class TagSearchAppend extends Vue {
  get tagsPlanLimit():keyof BillingLimits {
    switch (this.$route.params.type){
      case 'campaigns':
        return 'tagsCampaigns'
      case 'offers':
        return 'tagsOffers'
      case 'landings':
        return 'tagsLandings'
      case 'flows':
        return 'tagsFlows'
      case 'affiliate-networks':
        return 'tagsAffiliateNetworks'
      case 'traffic-sources':
        return 'tagsTrafficSources'
    }
  }
  get marksPlanLimit():keyof BillingLimits  {
    if(this.$route.params?.type?.includes('custom')) return 'markersCustomParams';
    switch (this.$route.params?.type){
      case 'campaigns':
        return 'markersCampaigns'
      case 'offers':
        return 'markersOffers'
      case 'landings':
        return 'markersLandings'
      case 'flows':
        return 'markersFlows'
      case 'affiliate-networks':
        return 'markersAffiliateNetworks'
      case 'traffic-sources':
        return 'markersTrafficSources'
      default:
        return null
    }
  }
  
  get items(): Bemob.ListItem[] {
    return [
      {
        key: 'text-and',
        title: this.t('Text (AND)'),
        iconAppend: 'fas fa-text',
        showCondition: true,
      },
      {
        key: 'text-or',
        title: this.t('Text (OR)'),
        iconAppend: 'fas fa-text',
        showCondition: true,
      },
      {
        key: 'tags-and',
        title: this.t('Tags (AND)'),
        iconAppend: 'fas fa-tags',
        showCondition: true,
        planLimits:this.tagsPlanLimit
      }, 
      {
        key: 'tags-or',
        title: this.t('Tags (OR)'),
        iconAppend: 'fas fa-tags',
        showCondition: true,
        planLimits:this.tagsPlanLimit
      }, 
      {
        key: 'marks-include',
        title: this.t('Marks (Inc)'),
        iconAppend: 'fas fa-heart',
        showCondition: this.hasMarks,
        planLimits:this.marksPlanLimit
      },
      {
        key: 'marks-exclude',
        title: this.t('Marks (Exc)'),
        iconAppend: 'fas fa-heart',
        showCondition: this.hasMarks,
        planLimits:this.marksPlanLimit
      }
    ]
  }

  get selectedItem() {
    return this.items.find((item) => item.key === this.selected) || {};
  }

  get pItems(): Bemob.ListItem[] {
    return this.items
      .map((item) => {
        return {
          ...item,
          click: () => this.handleItemClick(item)
        };
      })
      .filter((item) => item.showCondition);
  }

  @Prop()
  hasClear: boolean;
  
  @Prop()
  hasMarks: boolean;

  @Prop()
  hideTags: boolean;

  @Prop()
  selected: string;

  @Emit('update:selected')
  onUpdateSelected(value: string) {}

  @Emit('clear')
  onClear() {}

  handleItemClick(item: Bemob.ListItem) {
    this.onUpdateSelected(item.key);
  }

  handleClick() {
    this.$emit('click');
  }

  //.ui-menu-content-item__text
}
